module.exports = {"431028101":"安平镇","431028102":"龙海镇","431028105":"灵官镇","431028106":"永乐江镇","431028107":"金紫仙镇","431028201":"龙市乡","431028204":"渡口乡","431028205":"华王乡","431028206":"牌楼乡","431028207":"平背乡","431028209":"承坪乡","431028210":"竹山乡","431028214":"洋际乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431028.json
// module id = 1736
// module chunks = 0